import React, { useEffect, useState } from "react";
import { Checkbox, ColorPicker, Input, message } from "antd";
import NutritionDrawer, { DrawerFooter } from "@components/nutrition/nutrition-drawer";
import { createSprCardVid, updateSprCardVid } from "./spr-cards-api";
import { cardColorHex, cardHexToColor } from "@core/card-keys";
import "./spr-cards.css";

const emptyForm = () => ({ vid: null, name: "", color: "#ffffff", isGetOnExit: false, isCardDolg: false });

const SprCardVidDrawer = ({ vid, open, onClose, onSaved, canEdit }) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [edit, setEdit] = useState(emptyForm());
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setEdit(vid
      ? {
          vid: vid.vid,
          name: vid.name,
          color: cardColorHex(vid.color),
          isGetOnExit: Number(vid.isGetOnExit) === 1,
          isCardDolg: Number(vid.isCardDolg) === 1
        }
      : emptyForm());
  }, [open, vid]);

  const save = async () => {
    if (!edit.name.trim()) {
      messageApi.warning("Введите название типа");
      return;
    }
    setSaving(true);
    const bodyData = {
      name: edit.name.trim(),
      color: cardHexToColor(edit.color),
      isGetOnExit: Boolean(edit.isGetOnExit),
      isCardDolg: Boolean(edit.isCardDolg)
    };
    try {
      if (edit.vid) {
        await updateSprCardVid(edit.vid, bodyData);
      } else {
        await createSprCardVid(bodyData);
      }
      messageApi.success("Сохранено");
      onSaved?.();
      onClose?.();
    } catch (e) {
      messageApi.error(e?.message || "Не удалось сохранить");
    } finally {
      setSaving(false);
    }
  };

  return (
    <NutritionDrawer open={open} title={edit.vid ? "Тип карты" : "Новый тип карты"} width={420} onClose={onClose}>
      {contextHolder}
      <div className="spr-cards-vid-form">
        <Input
          placeholder="Название типа"
          value={edit.name}
          onChange={(e) => setEdit((x) => ({ ...x, name: e.target.value }))}
        />
        <ColorPicker
          value={edit.color}
          onChange={(c) => setEdit((x) => ({ ...x, color: c.toHexString() }))}
        />
        <Checkbox checked={edit.isGetOnExit} onChange={(e) => setEdit((x) => ({ ...x, isGetOnExit: e.target.checked }))}>
          Забирать на выходе
        </Checkbox>
        <Checkbox checked={edit.isCardDolg} onChange={(e) => setEdit((x) => ({ ...x, isCardDolg: e.target.checked }))}>
          Долговая
        </Checkbox>
      </div>
      <DrawerFooter
        onSave={canEdit ? save : null}
        onClose={onClose}
        saving={saving}
        saveText={edit.vid ? "Сохранить" : "Добавить"}
      />
    </NutritionDrawer>
  );
};

export default SprCardVidDrawer;
